import { computed, ref } from 'vue';

export function useImageDownloaderSingleton() {
  // after adding handleLoadAsset to any asset this value needs to be updated manually
  const TOTAL_ASSETS_TO_LOAD = 228;

  const loaded = ref(0);
  const total = ref(TOTAL_ASSETS_TO_LOAD);

  const progress = computed(() =>
    total.value === 0 ? 0 : Math.floor((loaded.value / total.value) * 100),
  );
  const isFinished = computed(() => progress.value >= 100);

  const handleLoadAsset = () => {
    if (loaded.value < total.value) {
      loaded.value++;
    }
  };

  return { progress, isFinished, handleLoadAsset, loaded };
}

const cached = useImageDownloaderSingleton();
export const useImageDownloader = () => cached;
